import { type Variants } from "framer-motion";

export const swViewport = { once: false, amount: 0.18 } as const;

export const swEase = [0.22, 1, 0.36, 1] as const;

export const swFloatUp: Variants = {
    hidden: { opacity: 0, y: 48 },
    visible: (delay = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: swEase, delay },
    }),
};

export const swFade: Variants = {
    hidden: { opacity: 0 },
    visible: (delay = 0) => ({
        opacity: 1,
        transition: { duration: 0.65, ease: swEase, delay },
    }),
};

export const swSlideLeft: Variants = {
    hidden: { opacity: 0, x: -56 },
    visible: (delay = 0) => ({
        opacity: 1,
        x: 0,
        transition: { duration: 0.65, ease: swEase, delay },
    }),
};

export const swSlideRight: Variants = {
    hidden: { opacity: 0, x: 56 },
    visible: (delay = 0) => ({
        opacity: 1,
        x: 0,
        transition: { duration: 0.65, ease: swEase, delay },
    }),
};

export const swZoom: Variants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: (delay = 0) => ({
        opacity: 1,
        scale: 1,
        transition: { duration: 0.55, ease: swEase, delay },
    }),
};

export const swStagger: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1, delayChildren: 0.06 } },
};
